import(/* webpackMode: "eager" */ "/vercel/path0/app/youtube-thumbnail-downloader/page.tsx");
